import {commonActions} from '../../actions/commonActions';
import {productSetList} from '../../actions/productActions';
import {connect} from 'react-redux';
import List from '../../components/product/ProductList';
import {API_FETCH} from '../../services/FetchService';
import {list as categoryList} from '../../containers/product/CategoryListPage';
import {commonConstants} from "../../constants";


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    getCategoryList : () => {
        return(dispatch(categoryList({size: 100})));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

export const list = (value) => {
    return (dispatch, getState) => {

        let states = getState()

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('product/product',{params: value}).then(list => {
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(productSetList(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.product.list,
        categoryList : state.product.categoryList,
        common       : state.common,
        initialValues: state.product.targetItem
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);
